import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { API_BASE_URL, API_FORMBRICKS_URL } from "../../appConstants";

export const getCurrentToken = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const tokenFromQuery = urlParams.get("lumitoken");
    const tokenFromStorage = localStorage.getItem("lumitoken");
    return tokenFromStorage || tokenFromQuery;
};
const accessToken = getCurrentToken();

const handle401Error = () => {
    localStorage.removeItem("lumitoken");
    localStorage.removeItem("loggedIn");
    window.location.href = '/app/login';
};

export const lumiApi = createApi({
    reducerPath: "lumiApi",
    tagTypes: ["Projects", "Tasks"],
    baseQuery: fetchBaseQuery({
        baseUrl: `${API_BASE_URL()}/api/v5/`,
        prepareHeaders: (headers, { getState, endpoint, extra }) => {
            const state = getState();
            const accessTokenFromState = state.auth.token;

            const token = accessTokenFromState || accessToken;
            const longLivedToken = localStorage.getItem("long_lived_token");
            if (endpoint === "exportResponses") {
                headers.set("Authorization", `Token ${longLivedToken}`);
                return headers;
            }
            if (token) {
                headers.set("Authorization", `Token ${token}`);
                // headers.set("Content-Type", `application/json`);
            }
            return headers;
        },
        responseHandler: async (response) => {
            const res = await response.json();
            if (res.error === "AUTH_CREDS_INVALID"){
                throw new Error("User credentials invalid")
            }
            if (response.status === 401) {
                handle401Error();
                return;
            }
            if (res.status && res.status === "success") {
                return res;
            } else if (res.error ?? res.error === "INADEQUATE_PERMISSION") {
                throw new Error(
                    JSON.stringify({
                        project_id: res.project_id,
                        permission: res.permission,
                        error: res.error,
                        message: res.message,
                    })
                );
            } else {
                return res; // TODO: Implement error handling
            }
        },
    }),
    endpoints: (builder) => ({
        getDefaultRequest: builder.query({
            query: () => "/",
        }),
    }),
});

export const formbricksApi = createApi({
    reducerPath: "formbricksApi",
    tagTypes: ["Surveys", "Survey"],
    baseQuery: fetchBaseQuery({
        baseUrl: API_FORMBRICKS_URL(),
        prepareHeaders: (headers, { getState, endpoint, extra }) => {
            const state = getState();
            const accessTokenFromState = state.auth.token;
            const token = accessTokenFromState || accessToken;
            if (token) {
                headers.set("Authorization", `Token ${token}`);
                headers.set("x-api-key", accessToken);
            }
            return headers;
        },
        responseHandler: async (response) => {
            if (response.status === 401) {
                handle401Error();
                return;
            }
            const res = await response.json();
            if (res.data) {
                return res.data;
            } else {
                return res;
            }
        },
    }),
    endpoints: (builder) => ({
        getDefaultRequest: builder.query({
            query: () => "/",
        }),
    }),
});
